const APIURL = "https://hotellele.com/fcrm/api/";
//const APIURL = "http://localhost/fcrm/api/";
const GET_CITIES_URL = APIURL + "getCitiesBySearch";
const GET_FEATURED_CITIES_URL = APIURL + "getFeaturedCities";
const GET_HOTELS = APIURL + "getHotels";
const GET_HOTEL_DETAIL = APIURL + "getSingleHotel";
const GET_HOTEL_SEARCH = APIURL + "getHotelsSearch";
const GET_ROOM_DETAIL = APIURL + "getSingleRoom";
const GET_HOMEPAGE_DATA = APIURL + "getHomepageData";
const REGISTER_URL = APIURL + "registerApi";
const LOGIN_URL = APIURL + "loginApi";
const VALIDATE_PROMOCODE = APIURL + "validateCoupon";
const BOOK_URL = APIURL + "bookOrder";
const GET_ORDERS = APIURL + "get_orders";
const GET_ORDER_DETAIL = APIURL + "get_order";
const GET_GETUSER_DETAIL= APIURL +"get_userdetail";
const GET_USERDETAIL_UPDATE=APIURL+"update_userdetail";
const GET_ViSA_DATA=APIURL+"get_countryforvisa";
const GET_COUNTRY=APIURL+"get_countryBysearch";
const GET_COUNTRYVISADETAIL=APIURL+"get_visaDetails";
const GET_VISAENTRY=APIURL+"get_visaentry";

export const APIURLS = Object.freeze({
    APIURL: APIURL,
    GET_CITIES: GET_CITIES_URL,
    GET_FEATURED_CITIES: GET_FEATURED_CITIES_URL,
    GET_HOTELS: GET_HOTELS,
    GET_HOTEL_DETAIL: GET_HOTEL_DETAIL,
    GET_ROOM_DETAIL: GET_ROOM_DETAIL,
    GET_HOMEPAGE_DATA: GET_HOMEPAGE_DATA,
    REGISTER_URL: REGISTER_URL,
    LOGIN_URL: LOGIN_URL,
    VALIDATE_PROMOCODE:VALIDATE_PROMOCODE,
    GET_HOTEL_SEARCH: GET_HOTEL_SEARCH,
    BOOK_URL: BOOK_URL,
    GET_ORDERS: GET_ORDERS,
    GET_ORDER_DETAIL: GET_ORDER_DETAIL,
    GET_GETUSER_DETAIL:GET_GETUSER_DETAIL,
    GET_USERDETAIL_UPDATE:GET_USERDETAIL_UPDATE,
    GET_ViSA_DATA:GET_ViSA_DATA,
    GET_COUNTRY:GET_COUNTRY,
    GET_COUNTRYVISADETAIL:GET_COUNTRYVISADETAIL,
    GET_VISAENTRY:GET_VISAENTRY

});